export const DASHBOARD_FETCH_STARTED = 'DASHBOARD_FETCH_STARTED';
export const DASHBOARD_FETCH_SUCCESS = 'DASHBOARD_FETCH_SUCCESS';
export const DASHBOARD_FETCH_FINISH = 'DASHBOARD_FETCH_FINISH';
export const DASHBOARD_FETCH_ERROR = 'DASHBOARD_FETCH_ERROR';
export const DASHBOARD_RESETED = 'DASHBOARD_RESETED';